const installViewportHeight = () => {
  function updateVH() {
    document.documentElement.style.setProperty('--vh-mobile', window.innerHeight + 'px');
  }
  window.addEventListener('resize', updateVH);
  window.addEventListener('orientationchange', updateVH);
  updateVH();
  return () => {
    window.removeEventListener('resize', updateVH)
    window.removeEventListener('orientationchange', updateVH)
  }
}

export {
  installViewportHeight,
}
